module.exports = __webpack_public_path__ + "img/073498.1e06389f.png";